export const leadsData = [
  {
    id: 1,
    si_no: "",
    select: "",
    lead_name: "Collins",
    customer_company: "",
    company_image: "assets/img/icons/company-icon-01.svg",
    company_address: "Newyork, USA",
    phone: "+970542396200",
    email: "robertson@example.com",
    created_date: "Fri Sep 06 2024",
    owner: "Espinosa",
    source: "Paid Social",
    status: "Win",
    Action: "",
    image: "assets/img/icons/company-icon-01.svg",
    key: "1",
  },
  {
    id: 2,
    si_no: "",
    select: "",
    lead_name: "KonopelskiKonopelski",
    customer_company: "BlueSky Industries",
    company_image: "assets/img/icons/company-icon-02.svg",
    company_address: "Winchester, KY",
    phone: "+1 989757485",
    email: "sharon@example.com",
    created_date: "29 Sep 2023, 04:15 pm",
    owner: "Theresa",
    source: "Referrals",
    status: "Interested",
    Action: "",
    image: "assets/img/icons/company-icon-02.svg",
    key: "2",
  },
  {
    id: 3,
    si_no: "",
    select: "",
    lead_name: "Adams",
    customer_company: "SilverHawk",
    company_image: "assets/img/icons/company-icon-03.svg",
    company_address: "Jametown, NY",
    phone: "+1 546555455",
    email: "vaughan12@example.com",
    created_date: "Fri Sep 06 2024",
    owner: "Theresa",
    source: "Campaigns",
    status: "Lost",
    Action: "",
    image: "assets/img/icons/company-icon-03.svg",
    key: "3",
  },
  {
    id: 4,
    si_no: "",
    select: "",
    lead_name: "Schumm",
    customer_company: "SummitPeak",
    company_image: "assets/img/icons/company-icon-04.svg",
    company_address: "Compton, RI",
    phone: "+1 454478787",
    email: "jessica13@example.com",
    created_date: "Fri Sep 06 2024",
    owner: "Espinosa",
    source: "Google",
    status: "Interested",
    Action: "",
    image: "assets/img/icons/company-icon-04.svg",
    key: "4",
  },
  {
    id: 5,
    si_no: "",
    select: "",
    lead_name: "Wisozk",
    customer_company: "RiverStone Ventur",
    company_image: "assets/img/icons/company-icon-05.svg",
    company_address: "Dayton, OH",
    phone: "+1 124547845",
    email: "caroltho3@example.com",
    created_date: "Fri Sep 06 2024",
    owner: "Espinosa",
    source: "Paid Social",
    status: "Contacted",
    Action: "",
    image: "assets/img/icons/company-icon-05.svg",
    key: "5",
  },
  {
    id: 6,
    si_no: "",
    select: "",
    lead_name: "Heller",
    customer_company: "Bright Bridge Grp",
    company_image: "assets/img/icons/company-icon-06.svg",
    company_address: "Lafayette, LA",
    phone: "+1 478845447",
    email: "dawnmercha@example.com",
    created_date: "Fri Sep 06 2024",
    owner: "Jami",
    source: "Referrals",
    status: "Win",
    Action: "",
    image: "assets/img/icons/company-icon-06.svg",
    key: "6",
  },
  {
    id: 7,
    si_no: "",
    select: "",
    lead_name: "Gutkowski",
    customer_company: "CoastalStar Co.",
    company_image: "assets/img/icons/company-icon-07.svg",
    company_address: "Centerville, VA",
    phone: "+1 215544845",
    email: "rachel@example.com",
    created_date: "Fri Sep 06 2024",
    owner: "Guillory",
    source: "Campaigns",
    status: "Contacted",
    Action: "",
    image: "assets/img/icons/company-icon-07.svg",
    key: "7",
  },
  {
    id: 8,
    si_no: "",
    select: "",
    lead_name: "Walter",
    customer_company: "HarborView",
    company_image: "assets/img/icons/company-icon-08.svg",
    company_address: "Providence, RI",
    phone: "+1 121145471",
    email: "jonelle@example.com",
    created_date: "Fri Sep 06 2024",
    owner: "Jerald",
    source: "Google",
    status: "Interested",
    Action: "",
    image: "assets/img/icons/company-icon-08.svg",
    key: "8",
  },
  {
    id: 9,
    si_no: "",
    select: "",
    lead_name: "Hansen",
    customer_company: "Golden Gate Ltd",
    company_image: "assets/img/icons/company-icon-09.svg",
    company_address: "Swayzee, IN",
    phone: "+1 321454789",
    email: "jonathan@example.com",
    created_date: "Fri Sep 06 2024",
    owner: "Guillory",
    source: "Paid Social",
    status: "Interested",
    Action: "",
    image: "assets/img/icons/company-icon-09.svg",
    key: "9",
  },
  {
    id: 10,
    si_no: "",
    select: "",
    lead_name: "Leuschke",
    customer_company: "Redwood Inc",
    company_image: "assets/img/icons/company-icon-10.svg",
    company_address: "Florida City, FL",
    phone: "+1 278907145",
    email: "brook@example.com",
    created_date: "Fri Sep 06 2024",
    owner: "Jerald",
    source: "Referrals",
    status: "Lost",
    Action: "",
    image: "assets/img/icons/company-icon-10.svg",
    key: "10",
  },
];
